import photo1 from "../../../assets/images/appImages/member-1.png"
import photo2 from "../../../assets/images/appImages/member-2.png"
import photo3 from "../../../assets/images/appImages/member-3.png"

export const TeamData = [
  {
    id: 1,
    photo: photo1,
    name: "Mme SENE Thiaba",
    role: "Secrétaire générale Trésorière du GIE Formulatrice des soins lavants",
  },
  {
    id: 3,
    photo: photo2,
    name: "Mme NDIAYE Dieynaba",
    role: "Présidente du GIE Formulatrice des soins capillaires",
  },
  {
    id: 3,
    photo: photo3,
    name: "Mme Ndiaye Oumou SOW",
    role: "Formulatrice des soins skincare",
  },

]
